var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouponFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31525 9.63594L1.9893 10.5813L2.31525 9.63594ZM2.31525 14.3641L1.9893 13.4187L2.31525 14.3641ZM21.6847 14.3641L22.0107 13.4187L21.6847 14.3641ZM21.6847 9.63594L21.3588 8.69056L21.6847 9.63594ZM6 3C3.23858 3 1 5.23858 1 8H3C3 6.34315 4.34315 5 6 5V3ZM18 3H6V5H18V3ZM23 8C23 5.23858 20.7614 3 18 3V5C19.6569 5 21 6.34315 21 8H23ZM23 9.22305V8H21V9.22305H23ZM21 12C21 11.3444 21.4212 10.7846 22.0107 10.5813L21.3588 8.69056C19.9874 9.16338 19 10.4651 19 12H21ZM22.0107 13.4187C21.4212 13.2154 21 12.6556 21 12H19C19 13.5349 19.9874 14.8366 21.3588 15.3094L22.0107 13.4187ZM23 16V14.777H21V16H23ZM18 21C20.7614 21 23 18.7614 23 16H21C21 17.6569 19.6569 19 18 19V21ZM6 21H18V19H6V21ZM1 16C1 18.7614 3.23858 21 6 21V19C4.34315 19 3 17.6569 3 16H1ZM1 14.777V16H3V14.777H1ZM2.64121 15.3094C4.01255 14.8366 5 13.5349 5 12H3C3 12.6556 2.57881 13.2154 1.9893 13.4187L2.64121 15.3094ZM5 12C5 10.4651 4.01255 9.16338 2.64121 8.69056L1.9893 10.5813C2.57881 10.7846 3 11.3444 3 12H5ZM1 8V9.22305H3V8H1ZM2.64121 8.69056C2.79023 8.74194 3 8.91284 3 9.22305H1C1 9.91373 1.48057 10.4059 1.9893 10.5813L2.64121 8.69056ZM3 14.777C3 15.0872 2.79023 15.2581 2.64121 15.3094L1.9893 13.4187C1.48057 13.5941 1 14.0863 1 14.777H3ZM21.3588 15.3094C21.2098 15.2581 21 15.0872 21 14.777H23C23 14.0863 22.5194 13.5941 22.0107 13.4187L21.3588 15.3094ZM21 9.22305C21 8.91284 21.2098 8.74194 21.3588 8.69056L22.0107 10.5813C22.5194 10.4059 23 9.91373 23 9.22305H21Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7L15 4",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5L15 10.5",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20L15 17",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponFull);
export default __webpack_public_path__ + "static/media/coupon_full.eb26fbdfef1190aab51c41a785e4e43b.svg";
export { ForwardRef as ReactComponent };